import { ThunkAction } from 'redux-thunk'
import { Action } from 'redux'

import {
  Consulta,
  EscolhaConsulta,
  ModalidadeAtendimento,
  OrigemTeleconsulta,
} from 'models/Consulta'
import { LocalSugestaoBackend } from 'models/Local'
import { FallbackPermitido } from 'models/Fallback'
import { SugestaoDeUnidadesElegibilidade } from 'models/Unidade'
import {
  START_CONSULTA,
  LIMPA_CONSULTA,
  ATUALIZA_ESCOLHA,
  ATUALIZA_MODALIDADE_ATENDIMENTO,
  REINICIA_CONSULTA,
  ATUALIZA_NUMERO_REQUISICAO,
  ATUALIZA_CONFIRMACAO,
  ATUALIZA_ORIGEM_TELECONSULTA,
  ATUALIZA_LOCAL_SUGESTOES,
  ATUALIZA_FALLBACK_PERMITIDO,
  LIMPA_FALLBACK_PERMITIDO,
  DEFINE_METADATA,
  JA_LISTOU_HORARIO,
} from './types'
import { AppState } from '../index'

export const limpaConsulta =
  (): ThunkAction<void, AppState, unknown, Action<string>> =>
  async (dispatch) => {
    dispatch({
      type: LIMPA_CONSULTA,
      payload: {},
    })
  }

export const reiniciaConsulta =
  (): ThunkAction<void, AppState, unknown, Action<string>> =>
  async (dispatch) => {
    dispatch({
      type: REINICIA_CONSULTA,
      payload: {},
    })
  }

export const atualizaConsulta =
  (consulta: Consulta): ThunkAction<void, AppState, unknown, Action<string>> =>
  async (dispatch) => {
    dispatch({
      type: START_CONSULTA,
      payload: consulta,
    })
  }

export const atualizaEscolha =
  (
    escolha?: EscolhaConsulta
  ): ThunkAction<void, AppState, unknown, Action<string>> =>
  async (dispatch) => {
    dispatch({
      type: ATUALIZA_ESCOLHA,
      payload: escolha || {
        escolhaPorMedico: false,
        escolhaPorEspecialidade: false,
      },
    })
  }

export const atualizaModalidadeAtendimento =
  (
    modalidadeAtendimento?: ModalidadeAtendimento
  ): ThunkAction<void, AppState, unknown, Action<string>> =>
  async (dispatch) => {
    dispatch({
      type: ATUALIZA_MODALIDADE_ATENDIMENTO,
      payload: modalidadeAtendimento || {
        agendamentoTeleconsulta: false,
      },
    })
  }

export const atualizaNumeroRequisicao =
  (
    numeroRequisicao?: string
  ): ThunkAction<void, AppState, unknown, Action<string>> =>
  async (dispatch) => {
    dispatch({
      type: ATUALIZA_NUMERO_REQUISICAO,
      payload: numeroRequisicao,
    })
  }

export const atualizaConfirmacao =
  (
    estaConfirmada: boolean
  ): ThunkAction<void, AppState, unknown, Action<string>> =>
  async (dispatch) => {
    dispatch({
      type: ATUALIZA_CONFIRMACAO,
      payload: estaConfirmada,
    })
  }

export const atualizaOrigemTeleconsulta =
  (
    origem: OrigemTeleconsulta
  ): ThunkAction<void, AppState, unknown, Action<string>> =>
  async (dispatch) => {
    dispatch({
      type: ATUALIZA_ORIGEM_TELECONSULTA,
      payload: origem,
    })
  }

export const atualizaLocalSugestoes =
  (
    sugestoes: LocalSugestaoBackend[] | SugestaoDeUnidadesElegibilidade[] = []
  ): ThunkAction<void, AppState, unknown, Action<string>> =>
  async (dispatch) => {
    dispatch({
      type: ATUALIZA_LOCAL_SUGESTOES,
      payload: sugestoes,
    })
  }

export const limpaLocalSugestoes =
  (): ThunkAction<void, AppState, unknown, Action<string>> =>
  async (dispatch) => {
    dispatch({
      type: ATUALIZA_LOCAL_SUGESTOES,
    })
  }

export const atualizaFallbackPermitido =
  (
    fallback: FallbackPermitido
  ): ThunkAction<void, AppState, unknown, Action<string>> =>
  async (dispatch) => {
    dispatch({
      type: ATUALIZA_FALLBACK_PERMITIDO,
      payload: fallback,
    })
  }

export const limpaFallbackPermitido =
  (): ThunkAction<void, AppState, unknown, Action<string>> =>
  async (dispatch) => {
    dispatch({
      type: LIMPA_FALLBACK_PERMITIDO,
    })
  }

export const defineMetadata =
  (): ThunkAction<void, AppState, unknown, Action<string>> =>
  async (dispatch) => {
    dispatch({
      type: DEFINE_METADATA,
    })
  }

export const jaListouHorario =
  (
    jaListouHorario: boolean
  ): ThunkAction<void, AppState, unknown, Action<string>> =>
  async (dispatch) => {
    dispatch({
      type: JA_LISTOU_HORARIO,
      payload: jaListouHorario,
    })
  }
